<script>
  import { onMount } from 'svelte'

  export let fields = {}

  let attrs = {}

  onMount(() => {
    const pairs = (fields.attrs || '').split('|')

    for (const pair of pairs) {
      const [key, value] = pair.split(':')

      attrs[key] = value
    }

    attrs = attrs

    try {
      if (window.Trustpilot && fields?.isTrustpilot) {
        window.Trustpilot.loadFromElement(document.getElementById(fields?.elementId))
      }
    } catch (err) {
      console.error(err)
    }
  })
</script>

{#if fields?.src}
  <body class="external-plugin">
    <script async={fields?.async} class={fields?.jsClass} src={fields?.src} {...attrs}></script>
  </body>
{/if}

{#if fields?.element}
  {@html fields?.element}
{/if}

<style>
  .external-plugin {
    min-height: 0px;
  }

</style>
<script context="module">export const svelteCompilerVersion = {"major":4,"minor":2,"patch":18};</script>